import request from '@/utils/request'

// getCocwList
export function getCocwList(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6600/getCocwList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getmActList66
export function getmActList66(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6600/getmActList66`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// epms6600List
export function epms6600List(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6600/epms6600List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epms6600Xls
export function epms6600Xls(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6600/epms6600Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epms6600Xls RES', res)

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `Console Material List.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}